import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDiamond: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDiamond"><Path fillRule="evenodd" clipRule="evenodd" d="M0.0859375 10L7.08594 3H16.9144L23.9144 10L12.0002 21.9142L0.0859375 10ZM10.9143 8L9.50012 6.58579L6.08591 10L9.50012 13.4142L10.9143 12L8.91434 10L10.9143 8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDiamond;
